export default "__VITE_ASSET__Dzhg88IX__"